import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { TestService } from './../../services/test.service';

@Component({
  selector: 'app-column-chart',
  templateUrl: './column-chart.component.html',
  styleUrls: ['./column-chart.component.scss']
})
export class ColumnChartComponent implements OnInit, OnChanges {
  @Input() chartdata: any;
  @Input() contract: any;
  @Input() selectdAsset:any;
  chart: Chart;
  progress = 0;
  // add point to chart serie
  add() {
    this.chart.addPoint(Math.floor(Math.random() * 10));
  }
  constructor(private testService: TestService) {




  }

  ngOnChanges(changes: any) {
    this.chartdata = changes.chartdata.currentValue;
    if (this.chartdata) {
      this.initChart();
    }
  }

  ngOnInit() {
    if (this.chartdata) {
      this.initChart();
    }
  }

  initChart() {
      this.progress = 50;
      console.log('inside chart' + this.chartdata);
      this.chart = new Chart({
        chart: {
          height: 520
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: this.chartdata.Months,
          gridLineWidth: 0
        }],
        yAxis: [{
          title: {
            text: 'Total Hours per Month'
          },
          lineWidth: 1
        }],
        plotOptions: {
          column: {
            grouping: false
          }
        },
        tooltip: {
          shared: true
        },
        legend: {
          layout: 'horizontal',
          align: 'right',
          verticalAlign: 'top',
          symbolHeight: 12,
          symbolWidth: 12,
          symbolRadius: 2,
          symbolPadding: 8,
          itemStyle: {
            fontWeight: '300'
          }
        },
        series: [{
          name: 'Actual Flight Hrs.',
          type: 'column',
          color: '#001f4e', /*'#dac458',*/
          data: this.chartdata.ActualHours,
        },
        /* {
          name: 'Anticipated Utilization',
          type: 'column',
          color: '#a3a7ac',
          data: this.chartdata.AnticipatedHours,
        },*/ {
          name: 'Previous Year Flight Hrs.',
          type: 'spline',
          color: '#52a0e2', /*'#5a5f65',*/
          data: this.chartdata.PreviousYearHours
        }]
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/charts/column-chart.component.ts